import {DrawFrmThing} from "../../../drawfrm/DrawFrmThing";
import {inches, lineBlueHeavy} from "../../../const";
import {FrmShape} from "../../../drawfrm/FrmShape";
import {FrameProfileArgs} from "./ProfileArgs";
import {FrmRefPoint} from "../../../drawfrm/FrmRefPoint";

// Double Egress
export class FrameProfileDE extends DrawFrmThing {

    primaryDoorAnchor = new FrmRefPoint();
    // top of the outer face; the frame-profile view aligns a clamshell mullion on this.
    faceAnchor = new FrmRefPoint();

    constructor(args: FrameProfileArgs) {
        super();
        const {detail, jambDepth, jambFace, view, app, left, swingIn, clamshell, hideFaces, hideFaceDims, flipY} = args;

        const shape = new FrmShape(`frameProfile:DE:${left ? "left" : "right"}`, {
            dimensionMode: view.dimensionMode,
            thing: this,
            app: app,
        });
        shape.strokeColor = lineBlueHeavy;
        shape.horizontalDimensionSide = left ? "left" : "right";
        if (!left) shape.invertX();
        if(swingIn !== !!flipY) shape.invertY();

        //  __
        // |  |-----------------|   top return hook + top face
        // |__|                 |
        //                |-----|   step 1
        //                |
        //          |-----|         step 2
        //  __      |
        // |  |-----|               bottom face + bottom return hook
        // |__|

        const hookLip = 0.4 * inches;  // horizontal lip of the return
        const hookDrop = 0.4 * inches; // depth of the return pocket
        const face = 2 * inches;       // top face width
        const step = 0.5 * inches;     // each inward step of the staircase
        const neck1 = 25;              // throat segments (flex with jamb depth)
        const neck2 = 40;
        const neck3 = 25;

        // top return hook (lip tip -> left -> up), opening to the right
        shape.start(0, 0);
        const topLip = shape.lineTo(-hookLip, 0);
        const topHook = shape.lineTo(0, -hookDrop);
        if(clamshell) { topLip.setPenUp(); topHook.setPenUp(); }
        else topHook.linkDimension(detail.topTab, "extended");

        // top face
        const topFace = shape.lineTo(face, 0).linkDimension(jambFace);

        // staircase down-and-left (double egress = two stepped rabbets)
        const step1 = shape.lineTo(0, neck1).linkDimension(detail.doubleEgressLip, "extended");
        shape.lineTo(-step, 0).linkDimension(detail.doubleEgressStep1, "extended");

        const step2 = shape.lineTo(0, neck2).linkDimension(detail.rabbetDepth, "extended");
        shape.lineTo(-step, 0).linkDimension(detail.doubleEgressStep2, "extended");

        shape.lineTo(0, neck3).dimMatches(step1);

        this.primaryDoorAnchor.setLocalPoint(step2.pointA);

        // bottom face (narrower than the top by both steps)
        const bottomFace = shape
            .lineTo(-(face - 2 * step), 0)
            .linkDimension(detail.doubleEgressSmallFace, "extended");

        // bottom return hook (down -> right lip), mirrors the top
        const bottomHook = shape.lineTo(0, -hookDrop);
        const bottomLip = shape.lineTo(hookLip, 0);
        if(clamshell) { bottomHook.setPenUp(); bottomLip.setPenUp(); }
        else bottomHook.linkDimension(detail.bottomTab, "extended");
        topLip.dimMatches(bottomLip);

        // mirror rules: steps and hook lips stay matched

        // jamb depth drives the overall throat (face-to-face)
        shape.addDimension(topFace.getStartpoint(), bottomFace.getEndpoint(), jambDepth);

        // clamshell secondary side: omit the top/bottom faces so the primary side's
        // faces cap the merged mullion (avoids a doubled/gapped cap).
        if(hideFaces) { topFace.setPenUp(); bottomFace.setPenUp(); }
        if(hideFaces || hideFaceDims) shape.hideDimensionsForVars([jambFace, jambDepth]);
        this.faceAnchor.setLocalPoint(topFace.getStartpoint());
        shape.done();
    }
}
